<template>
  <div class="flex flex-col py-4">
    <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="space-between">
      <div class="flex">
        <feather-icon
          class="mr-2"
          icon="FileTextIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        ></feather-icon>
        <h4>Informações Básicas</h4>
      </div>

      <vs-button
        class="ml-2 mobile-hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-basic-info' })"
      >
        Editar
      </vs-button>

      <vs-button
        class="ml-2 sm:hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-basic-info' })"
      />
    </vs-col>

    <hr class="my-4 line" />

    <div class="flex">
      <div v-if="show()" class="flex flex-col">
        <ul class="activity-timeline mobile-hidden">
          <li>
            <div
              class="timeline-icon"
              :style="{ backgroundColor: color }"
              key="timeline-basicInfo"
            >
              <feather-icon
                icon="FileTextIcon"
                svgClasses="text-white stroke-current w-5 h-5"
              />
            </div>
            <!-- TODO: Descomentar em uma próxima versão  -->
            <!-- <div class="flex pl-1 my-1" v-if="email != ''">
              <p><b>Nome Social:</b> {{ socialName }}</p>
            </div> -->

            <div class="flex pl-1 my-1" v-if="email != ''">
              <p><b>Pronome:</b> {{ pronoun }}</p>
            </div>

            <div class="flex pl-1 my-1" v-if="email != ''">
              <p><b>E-mail:</b> {{ email }}</p>
            </div>

            <div class="flex pl-1 my-1" v-if="telephone != ''">
              <p><b>Telefone:</b> {{ telephone }}</p>
            </div>

            <div class="flex pl-1 my-1" v-if="birthday != ''">
              <p><b>Data de nascimento:</b> {{ birthday }}</p>
            </div>

            <div class="flex pl-1 my-1" v-if="ssn != ''">
              <p><b>CPF:</b> {{ ssn }}</p>
            </div>
          </li>
        </ul>

        <div class="sm:hidden">
          <div class="flex pl-1 my-1" v-if="email != ''">
            <p><b>E-mail:</b> {{ email }}</p>
          </div>

          <div class="flex pl-1 my-1" v-if="telephone != ''">
            <p><b>Telefone:</b> {{ telephone }}</p>
          </div>

          <div class="flex pl-1 my-1" v-if="birthday != ''">
            <p><b>Data de nascimento:</b> {{ birthday }}</p>
          </div>

          <div class="flex pl-1 my-1" v-if="ssn != ''">
            <p><b>CPF:</b> {{ ssn }}</p>
          </div>
        </div>
      </div>
      <EmptyDetailCard
        v-else
        description="Você ainda não preencheu nenhuma informação básica..."
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";

import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("company", ["company"]),

    email() {
      return this.basicInfo != undefined ? this.basicInfo.email : "";
    },

    telephone() {
      return this.basicInfo != undefined ? this.basicInfo.telephone : "";
    },

    birthday() {
      return this.basicInfo != undefined ? this.basicInfo.birthday : "";
    },

    ssn() {
      return this.basicInfo != undefined ? this.basicInfo.ssn : "";
    },

    maritalStatus() {
      return this.basicInfo != undefined ? this.basicInfo.marital_status : "";
    },

    gender() {
      return this.basicInfo != undefined || this.basicInfo !== null
        ? this.basicInfo.gender == 0
          ? "Masculino"
          : this.basicInfo.gender == 1
          ? "Feminino"
          : "Outro"
        : "";
    },

    pcd() {
      return this.basicInfo && this.basicInfo.hasOwnProperty("pcd")
        ? this.basicInfo.pcd
        : "";
    },

    pronoun() {
      const _pronoun = get(this.$store, 'state.diversity.pronoun.name', null);
      return _pronoun ? _pronoun : 'Não informado';
    },

    socialName() {
      const _socialName = get(this.$store, 'state.diversity.social_name', null);
      return _socialName ? _socialName : 'Não informado';
    },
    
    color() {
      return get(this.$store, 'state.company.base_hexcolor', '#1551b1');
    },
  },

  methods: {
    show() {
      return Object.keys(this.basicInfo).length > 0;
    },
  },
  components: { EmptyDetailCard },
};
</script>

<style lang="scss">
hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
</style>
